import BigNumber from 'bignumber.js';
import CartItem from './CartItem';
/**
 * hold a shopping cart or wish list for a user.
 */
class Cart {
	constructor(customerId = null, cartType = null, items = []) {
		this.customerId = customerId;
		this.cartType = cartType;
		this.items = items;
	}

	/**
	 * deserialize a javascript object from the database into a cart object.
	 * @param {object} cart javascript object.
	 */
	deserialize(cart) {
		this.customerId = cart.customerId;
		this.cartType = cart.cartType;
		cart.items.forEach(item => {
			const cartItem = new CartItem(item.cartId);
			cartItem.storeId = item.storeId;
			cartItem.product = item.product;
			cartItem.quantity = item.quantity;
			cartItem.rentalStartDate = item.rentalStartDate;
			cartItem.rentalEndDate = item.rentalEndDate;
			cartItem.updatedOnUtc = item.updatedOnUtc;
			cartItem.isFreeShipping = item.isFreeShipping;
			cartItem.isShipEnabled = item.isShipEnabled;
			cartItem.additionalShippingCharge = item.additionalShippingCharge;
			cartItem.isTaxExempt = item.isTaxExempt;
			cartItem.productAttributeValues = item.productAttributeValues;

			this.items.push(cartItem);
		});
	}

	/**
	 * sum the total items in the cart
	 */
	sumTotalQuantity() {
		return this.items.reduce((total, item) => total + item.quantity, 0);
	}

	sumTotalPrice() {
		let total = new BigNumber(0);
		this.items.forEach(item => {
			const itemPrice = new BigNumber(item.product.price || 0);
			const itemTotalPrice = itemPrice.times(item.quantity);
			total = total.plus(itemTotalPrice);
		});
		// default rounding mode for toFormat is ROUND_HALF_UP - Rounds towards nearest neighbour.
		// If equidistant, rounds away from zero
		return total.toFormat(2);
	}
}

export default Cart;
